import { NgModule } from '@angular/core';

import { OrderRoutingModule } from './order.routing';
import { ListOrderComponent } from './list-order/list-order.component';
import { ShowOrderComponent } from './show-order/show-order.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ListOrderComponent, ShowOrderComponent],
  imports: [SharedModule, OrderRoutingModule]
})
export class OrderModule {}
